export default __webpack_public_path__ + "static/logo-c4c01b8babf1ef8c575409f9e3bef9e9.png";